import { Component } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { TranslocoDirective } from "@jsverse/transloco";
import { FormlyFieldConfig, FormlyForm } from "@ngx-formly/core";
import { DialogModule } from "primeng/dialog";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { FormPreviewDialogConfig } from "./form-preview-dialog.types";
import { FormService } from "../../../../services/form.service";
import { primeNgPageModules } from "../../../../shared/modules/prime-ng-common.module";
import { FormlyFieldConfigTranslatable } from "../../../../shared/types/form";

@Component({
  templateUrl: "./form-preview.dialog.html",
  imports: [...primeNgPageModules, ReactiveFormsModule, FormlyForm, DialogModule, TranslocoDirective],
})
export class FormPreviewDialog {
  public form = new FormGroup({});
  public model: Record<string, unknown> = {};
  public fields: FormlyFieldConfig[];

  constructor(
    public readonly ref: DynamicDialogRef,
    private readonly formService: FormService,
    private readonly config: DynamicDialogConfig<FormPreviewDialogConfig>,
  ) {
    this.fields = config.data?.fields
      ? this.formService.prepareFormFields([
          {
            fieldGroupClassName: "flex flex-col gap-8",
            fieldGroup: config.data.fields as FormlyFieldConfigTranslatable[],
          },
        ])
      : [];
  }
}
